import styled from 'styled-components';
import { IconButton } from '@mui/material';

import { Button } from 'components/Button';

export const NoticeContainer = styled.div`
  display: flex;
  align-items: baseline;
  flex-wrap: wrap;
  gap: ${({ theme }) => `${theme.spacing(0.5)} ${theme.spacing(1.5)}`};
  padding: ${({ theme }) => `${theme.spacing(0.5)} 0 ${theme.spacing(1.5)}`};
`;

export const NoticeText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const NoticeFact = styled.span`
  font-weight: 600;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const EarlierVersionContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1.5)};
  padding: ${({ theme }) => `${theme.spacing(1.5)} ${theme.spacing(2)}`};
  border-radius: 8px;
  background: ${({ theme }) => theme.tint.warning.medium};
  position: sticky;
  top: 0;
  z-index: 2;
`;

export const EarlierVersionHeading = styled.p`
  margin: ${({ theme }) => `0 0 ${theme.spacing(0.5)}`};
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const EarlierVersionDetail = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const BarActions = styled.div`
  display: flex;
  align-items: center;
  gap: ${({ theme }) => theme.spacing(1)};
  flex-shrink: 0;
`;

export const InlineButton = styled(Button)`
  flex-shrink: 0;
`;

export const LinkButton = styled(Button)`
  flex-shrink: 0;
  padding: 0;
  min-width: 0;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: 143%;
  letter-spacing: 0.17px;
  text-transform: none;

  &:hover {
    background: none;
    text-decoration: underline;
  }
`;

export const ValueContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
  width: 100%;
`;

export const AbsentValue = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.subtitle1.fontSize};
  font-style: italic;
  line-height: 143%;
  color: ${({ theme }) => theme.palette.text.disabled};
`;

export const DRAWER_PAPER_PROPS = {
  'aria-labelledby': 'version-history-title',
  sx: {
    minWidth: '35%',
    maxWidth: '35%',
    borderTopLeftRadius: '8px',
    borderBottomLeftRadius: '8px',
    backgroundColor: 'background.paper',
  },
};

export const CloseDrawerButton = styled(IconButton)`
  border-radius: 50%;
  border: 1px solid ${({ theme }) => theme.palette.grey[300]};
  width: 32px;
  height: 32px;

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const ListContainer = styled.div`
  display: flex;
  flex-direction: column;
  gap: ${({ theme }) => theme.spacing(0.5)};
`;

export const VersionButton = styled.button<{ $isActive: boolean }>`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(0.5)};
  width: 100%;
  padding: ${({ theme }) => theme.spacing(1.5)};
  border: none;
  border-radius: 8px;
  cursor: pointer;
  text-align: left;
  font-family: inherit;
  background: ${({ theme, $isActive }) => ($isActive ? theme.tint.primary.medium : 'transparent')};

  &:hover {
    background: ${({ theme, $isActive }) => ($isActive ? theme.tint.primary.medium : theme.palette.grey[100])};
  }
`;

export const VersionHeading = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: ${({ theme }) => theme.spacing(1)};
  width: 100%;
`;

export const VersionName = styled.span`
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  font-weight: 600;
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const VersionMeta = styled.span`
  font-size: ${({ theme }) => theme.typography.caption.fontSize};
  line-height: 166%;
  letter-spacing: 0.4px;
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const ChevronSlot = styled.span`
  display: flex;
  align-items: center;
  color: ${({ theme }) => theme.palette.text.secondary};

  svg {
    width: 18px;
    height: 18px;
  }
`;

export const InlineErrorContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: ${({ theme }) => theme.spacing(1)};
  padding: ${({ theme }) => `${theme.spacing(2)} 0`};
`;

export const InlineErrorText = styled.p`
  margin: 0;
  font-size: ${({ theme }) => theme.typography.body1.fontSize};
  line-height: 143%;
  letter-spacing: 0.17px;
  color: ${({ theme }) => theme.palette.text.primary};
`;

export const LoadingContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 200px;
`;
